// extracted by mini-css-extract-plugin
export default {"amp_social_list":"footer_amp_social_list__tK9cV"};